import React, { ReactNode } from "react";

import { TranslationsObject } from "@genericTypes/sharedTypes";
import { translate } from "@helpers/translationObjectFormatter";
import styles from "./styles.module.scss";
import { useQuery } from "@tanstack/react-query";

function Tooltip({
    tooltipMessageKey,
    children,
    className,
}: {
    tooltipMessageKey: string;
    children: ReactNode;
    className?: string;
}) {
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);
    return (
        <div className={styles.tooltip}>
            {children}

            <span className={`${styles.toolTipText} ${className as string}`}>
                {translate(translations, tooltipMessageKey)}
            </span>
        </div>
    );
}

export default Tooltip;
